import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { RemovePositionDialog } from "@/routes/_layout/settings/_panel/-components/remove-position-dialog"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/facilities/_list/$facilityId/positions/$positionId/remove",
)({
  component: RemovePosition,
})

function RemovePosition(): React.ReactElement {
  const { facilityId, positionId } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()
  const close = () =>
    navigate({
      to: "/settings/workspace/facilities/$facilityId",
      params: { facilityId },
      search: true,
    })

  return (
    <RemovePositionDialog
      owner={{ facility_id: facilityId }}
      positionId={positionId}
      onRemoved={(removed) => {
        showToast("Removed", `${removed.name} removed.`, "success")
        close()
      }}
      onClose={close}
    />
  )
}
